import { AfterViewInit, Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SelfAttendanceService } from '../../shared/services/self-attendance.service';
import { MatDialog } from '@angular/material/dialog';
import { LoadingComponent } from 'src/app/shared/components/loading/loading.component';
import { cssBrands } from '../../shared/constants/cards';
import { Location } from '@angular/common';

import {
  authReasonCode,
  bankBillet2ndCopyErrors,
  pix2ndCopyErrors,
  paymentMethodErrors,
  braspagReasonCode, adyenReasonCode,
  errorMapping,
  handleIntegrationError, paymentChangeDataError
} from '../../shared/constants/errors';
import { PaymentFormComponent } from '../../shared/components/payment-form/payment-form.component';
import { DtmService } from '../../services/dtm.service';
import { PaymentMethodOption } from '../../shared/model/payment-method-option';
import { SelfAttendanceData } from '../../shared/model/self-attendance-data';
import { ProductService } from '../../shared/services/product.service';
import { Dtm, getDtm } from '../../shared/enum/dtm';
import { SYDLEClientID } from '../../shared/constants/one-constants';
import { SessionStorageService } from "../../shared/services/session-storage.service";
import { DialogAlertComponent } from 'src/app/shared/components/dialog-alert/dialog-alert.component';
import { DialogData } from 'src/app/shared/model/dialog-data';
import { Product } from 'src/app/shared/model/product';
import { LoadingService } from 'src/app/shared/services/loading.service';
import { BreadcrumbService } from 'src/app/shared/services/breadcrumb.service';
import { CreditCardData } from 'src/app/shared/model/credit-card-data';
import { Discount } from 'src/app/shared/model/discount';

@Component({
    selector: 'pme-self-attendance-payment-change',
    templateUrl: './payment-change.component.html',
    styleUrls: ['./payment-change.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SelfAttendancePaymentChangeComponent implements OnInit {
  hashString: string;
  redirectUrl: string;
  originOfRequest: string;
  contractCode: string;
  businessId: string;
  userId: string;
  selfAttendanceData: SelfAttendanceData;
  paymentMethod: string;
  location: Location;
  currentPaymentMethod: string;
  classificationIdentifier: string;

  heroData: any = {};
  currentPlanData: any;
  showHero: boolean;
  currentProduct: Product;

  changePaymentMethodDiscount: Discount;
  changePaymentMethodDiscountFound: boolean;
  discountBadgeCreditCard: string;
  termOfUse: string;

  @ViewChild(PaymentFormComponent) paymentForm: PaymentFormComponent;

  showForm: boolean;
  paymentOptions: Array<PaymentMethodOption>;
  showCurrentPlan: boolean;
  buttonName: any;

  paymentChangeMessage: string;

  creditCardsData: CreditCardData[];
  maxLimitCreditCards: boolean;
  creditCardData: CreditCardData;

  showErrorHero: boolean = false;

  isITP: boolean = true;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    public dialog: MatDialog,
    public dtmService: DtmService,
    private productService: ProductService,
    private selfAttendanceService: SelfAttendanceService,
    public sessionStorageService: SessionStorageService,
    private loading: LoadingService,

  ) {
    this.classificationIdentifier = this.sessionStorageService.getClassification(route);
    this.route.queryParams.subscribe((params) => {
      this.hashString = params.hash;
      this.originOfRequest = params.origin;

      this.userId = params.userId;
      this.businessId = params.businessId;
      // this.loadDtmPageLoad();
      sessionStorage.setItem('selfAttendance', 'true');

      if (params.redirectUrl) {
        this.redirectUrl = params.redirectUrl;
        sessionStorage.setItem('redirectUrl', this.redirectUrl);
        this.selfAttendanceService.redirectURL = this.redirectUrl;
      }

    });

    selfAttendanceService.getStoredCreditCards(this.userId, this.businessId, this.hashString).subscribe(results => {
      this.creditCardsData = results[0].length ? results[0] : null;
      this.maxLimitCreditCards = results[1];
    });

    selfAttendanceService.getStoredCreditCard(this.userId, this.businessId)
      .subscribe(r => {
        this.creditCardData = r;
      });
  }
  getBrandCSSMatching(brand: string): string {
    return cssBrands[brand];
  }
  openDialogSpinner(): void {
    this.closeDialogSpinner();
    this.dialog.open(LoadingComponent, {
      disableClose: true,
      width: "400px",
      panelClass: "pme-dialog-loading-panel",
      backdropClass: 'pme-dialog-loading-backdrop'
    });
  }


  ngOnInit() {

    this.openDialogSpinner();
    this.selfAttendanceService.authenticate(this.classificationIdentifier, this.hashString, this.businessId, this.userId, false).subscribe(
      (authData) => {
        if (authData.userName && authData.userEmail) {
          sessionStorage.setItem('name', authData.userName);
          sessionStorage.setItem('email', authData.userEmail);
        }

        this.businessId = authData.businessId;
        this.userId = authData.userId;

        this.dtmService.userLoaded({
          userId: this.userId,
          businessId: this.businessId,
          clientId: SYDLEClientID
        });

        this.bindHeroInformation();

        if (this.originOfRequest === '2via') {
          this.selfAttendanceService.getBusinessPaymentMethod(authData.businessId, authData.userId, this.classificationIdentifier).subscribe(
            (result) => {
              this.paymentMethod = result.paymentMethod;
              if (this.paymentMethod === "BANK_BILLET") {
                this.selfAttendanceService.getBankBillet2ndCopy(authData.businessId, authData.userId, this.classificationIdentifier).subscribe(
                  (selfAttendanceData) => {
                    if (selfAttendanceData && selfAttendanceData.bankBilletData) {
                      selfAttendanceData.businessId = authData.businessId;
                      selfAttendanceData.userId = authData.userId;
                      this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
                      this.closeDialogSpinner();
                      this.router.navigate(['../sucesso'], { relativeTo: this.route });
                    }
                  },
                  (error) => {
                    this.showCustomError('bankBillet2ndCopyError', error);
                    this.closeDialogSpinner();
                  }
                )

              } else if (this.paymentMethod === "PIX") {
                this.selfAttendanceService.getPix2ndCopy(authData.businessId, authData.userId, this.classificationIdentifier).subscribe(
                  (selfAttendanceData) => {
                    if (selfAttendanceData && selfAttendanceData.pixData) {
                      selfAttendanceData.businessId = authData.businessId;
                      selfAttendanceData.userId = authData.userId;
                      this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
                      this.closeDialogSpinner();
                      this.router.navigate(['../sucesso'], { relativeTo: this.route });
                    }
                  },
                  (error) => {
                    this.showCustomError('pix2ndCopyError', error);
                    this.closeDialogSpinner();
                  }
                )

              } else {
                this.showCustomError('paymentMethodError', "Serviço indiponível");
                this.closeDialogSpinner();
              }
            },
            (error) => {
              this.showCustomError('paymentMethodError', error);
              this.closeDialogSpinner();
            }
          )
        } else {
          this.selfAttendanceService.getPaymentChangeData(authData.businessId, authData.userId, this.classificationIdentifier, this.originOfRequest).subscribe(
            (selfAttendanceData: SelfAttendanceData) => {
              selfAttendanceData.businessId = authData.businessId;
              selfAttendanceData.userId = authData.userId;

              this.termOfUse = selfAttendanceData.tdu;

              if (this.originOfRequest) {
                if (this.originOfRequest === 'invoicingError') {
                  this.dtmService.customLoaded(["AddToCart", "Checkout"], 'Sydle-pagamento-invalido');
                } else if (this.originOfRequest === 'expiredBankBillet') {
                  this.dtmService.customLoaded(["AddToCart", "Checkout"], 'Sydle-seu-boleto-venceu');
                }
                selfAttendanceData.service = this.originOfRequest;
              } else {
                if (selfAttendanceData.contract.status === 'ACTIVE') {
                  this.paymentChangeMessage = 'Na próxima renovação, enviaremos um e-mail com as informações de pagamento.';
                }
                selfAttendanceData.service = 'paymentChange';
              }

              this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);

              if (selfAttendanceData.paymentOptions && selfAttendanceData.contract) {
                this.paymentOptions = selfAttendanceData.paymentOptions;

                this.dtmService.productsLoaded([{
                  identifier: selfAttendanceData.contract.product.identifier,
                  classificationName: selfAttendanceData.contract.product.classificationName // 'Saúde do seu negócio'
                }]);

                this.currentPaymentMethod = selfAttendanceData.contract.paymentMethod.identifier;

                this.currentProduct = selfAttendanceData.contract.product;

                this.selfAttendanceService.getChangePaymentMethodDiscount(authData.businessId, authData.userId, this.classificationIdentifier, this.currentProduct._id).subscribe(
                  (result) => {
                    if (result.discount) {
                      this.changePaymentMethodDiscount = result.discount;
                      this.changePaymentMethodDiscountFound = true;
                      this.discountBadgeCreditCard = result.discount.deal.rateRules.parcels[0].value;
                    } else {
                      this.changePaymentMethodDiscountFound = false;
                    }

                  }
                );

                this.showCurrentPlan = true;
                this.currentPlanData = {}
                if (selfAttendanceData.bankBilletData) {
                  this.currentPlanData.planName = selfAttendanceData.bankBilletData.planName;
                  this.currentPlanData.invoiceDate = selfAttendanceData.bankBilletData.invoiceDate;
                  this.currentPlanData.totalValue = selfAttendanceData.bankBilletData.totalValue;
                } else if (selfAttendanceData.pixData) {
                  this.currentPlanData.planName = selfAttendanceData.pixData.planName;
                  this.currentPlanData.invoiceDate = selfAttendanceData.pixData.invoiceDate;
                  this.currentPlanData.totalValue = selfAttendanceData.pixData.totalValue;
                } else if (selfAttendanceData.creditCardData) {
                  this.currentPlanData.planName = selfAttendanceData.creditCardData.planName;
                  this.currentPlanData.invoiceDate = selfAttendanceData.creditCardData.invoiceDate;
                  this.currentPlanData.totalValue = selfAttendanceData.creditCardData.totalValue;
                  this.currentPlanData.creditCard = selfAttendanceData.creditCardData.getFinalNumber();
                  this.currentPlanData.brand = selfAttendanceData.creditCardData.getBrandCSSMatching();

                }

                this.showForm = true;
                this.dtmService.sendPageLoadEvent();
                this.closeDialogSpinner();
              }
            },
            (error) => {
              this.showCustomError('paymentChangeDataError', error);
              this.closeDialogSpinner();
            }
          );
        }
      },
      (error) => {
        this.showCustomError('authenticationError', error);
        this.closeDialogSpinner();
      }
    );
  }

  closeDialogSpinner(): void {
    this.dialog.closeAll();
  }

  formatCreditCardNumber(cardNumber: string): string {
    return cardNumber.slice(-4);
  }
  onPaymentMethodSelected(paymentMethod) {
    if (!this.originOfRequest) {
      this.buttonName = 'Finalizar alteração';
    } else if (this.originOfRequest === 'invoicingError') {
      if (paymentMethod === 'BANK_BILLET') {
        this.buttonName = 'Gerar boleto';
      } else if (paymentMethod === 'CREDIT_CARD') {
        this.buttonName = 'Alterar cartão e finalizar pagamento'
      } else if (paymentMethod === 'PIX') {
        this.buttonName = 'Gerar chaves e finalizar pagamento'
      }
    } else if (this.originOfRequest === 'expiredBankBillet') {
      if (paymentMethod === 'BANK_BILLET') {
        this.buttonName = 'Gerar boleto';
      } else if (paymentMethod === 'CREDIT_CARD') {
        this.buttonName = 'Alterar cartão e finalizar pagamento'
      } else if (paymentMethod === 'PIX') {
        this.buttonName = 'Gerar chaves e finalizar pagamento'
      }
    }
  }

  /**
   * Função responsável por montar o hero de pagamento.
   */
  bindHeroInformation() {
    this.heroData = {};
    switch (this.originOfRequest) {
      case '2via':
        this.heroData.type = 'success';
        this.heroData.title = 'Gerando uma segunda via...';
        if (this.classificationIdentifier === 'saude-do-seu-negocio') {
          this.heroData.contents = [
            'Efetue o pagamento e não perca o acesso ao Saúde do seu Negócio.',
            'Caso já tenha pago, não se preocupe, o pagamento será processado' //o prazo de compensação do boleto é de até 3 dias úteis.'
          ];
        } else {
          this.heroData.contents = [
            'Caso já tenha pago, não se preocupe, o pagamento será processado' //o prazo de compensação do boleto é de até 3 dias úteis.'
          ];
        }

        this.dtmService.pageLoaded(Dtm.SegundaVia, true, getDtm(Dtm.SegundaVia, this.classificationIdentifier));
        //this.dtmService.sendPageLoadEvent();
        this.showHero = true;
        break;
      case 'invoicingError':
        this.heroData.type = 'warn';
        this.heroData.title = 'Não foi possível efetuar o pagamento!';
        if (this.classificationIdentifier === 'saude-do-seu-negocio') {
          this.heroData.contents = [
            'Insira um novo cartão para não perder acesso ao Saúde do seu Negócio.'
          ];
        } else if (this.classificationIdentifier === 'consulta-e-recuperacao-de-dividas') {
          this.heroData.contents = [
            'Insira um novo cartão para não deixar de realizar consultas e recuperar dívidas.'
          ];
        }

        this.dtmService.pageLoaded(Dtm.RetencaoCartaoInvalido, true, getDtm(Dtm.RetencaoCartaoInvalido, this.classificationIdentifier));
        //this.dtmService.sendPageLoadEvent();

        this.showHero = true;
        break;
      case 'expiredBankBillet':
        this.heroData.type = 'warn';
        this.heroData.title = 'Seu boleto venceu!';

        if (this.classificationIdentifier === 'saude-do-seu-negocio') {
          this.heroData.contents = [
            'Ainda não identificamos o seu pagamento. Caso você tenha efetuado, não se preocupe, o prazo de compensação do boleto é de 3 dias úteis.',
            'Se você ainda não pagou, utilize um cartão de crédito ou gere um novo boleto para não perder o acesso ao Saúde do seu Negócio.'
          ];
        } else if (this.classificationIdentifier === 'consulta-e-recuperacao-de-dividas') {
          this.heroData.contents = [
            'Ainda não identificamos o seu pagamento. Caso você tenha efetuado, não se preocupe, o prazo de compensação do boleto é de 3 dias úteis.',
            'Se você ainda não pagou, utilize um cartão de crédito ou gere um novo boleto para continuar realizando consultas e recuperar dívidas.'
          ];
        }

        this.dtmService.pageLoaded(Dtm.RetencaoBoletoVencido, true, getDtm(Dtm.RetencaoBoletoVencido, this.classificationIdentifier));
        //this.dtmService.sendPageLoadEvent();

        this.showHero = true;
        break;
      default:
        this.heroData.type = 'money-info';
        this.heroData.title = 'Alterar forma de pagamento';

        if (this.classificationIdentifier === 'saude-do-seu-negocio') {
          this.heroData.contents = [
            'Escolha como você deseja realizar o pagamento do seu plano. Utilizaremos estes dados para as futuras cobranças.'
          ];
        } else if (this.classificationIdentifier === 'consulta-e-recuperacao-de-dividas') {
          this.heroData.contents = [
            'Escolha como você deseja realizar o pagamento do seu pedido.'
          ];
        }
        else if (this.classificationIdentifier === 'plano-mensal') {
          this.heroData.contents = [
            'Escolha como você deseja realizar o pagamento do seu plano. Utilizaremos estes dados para as futuras cobranças.'
          ];
        }
        else {
          this.heroData.contents = [
            'Escolha como você deseja realizar o pagamento do seu plano. Utilizaremos estes dados para as futuras cobranças.'
          ];
        }

        this.dtmService.pageLoaded(Dtm.AlteracaoDePagamento, true, getDtm(Dtm.AlteracaoDePagamento, this.classificationIdentifier));
        //this.dtmService.sendPageLoadEvent();

        this.showHero = true;
        break;
    }

  }

  onPaymentChangePerform(paymentData) {

    this.dtmService.customClickEvent(this.buttonName);

    let requestData: any = {};
    requestData.paymentMethodIdentifier = paymentData.identifier;
    requestData.businessId = this.businessId;
    requestData.userId = this.userId;


    requestData.service = this.originOfRequest;


    if (paymentData.identifier === 'CREDIT_CARD') {
      requestData.defaultCard = paymentData.defaultCard;
      requestData.saveCard = paymentData.saveCard;
      requestData.nickname = paymentData.nickname;
      requestData.accountPaymentDataId = paymentData.accountPaymentDataId;
      if (paymentData.isAdyen) {
        requestData.cardNumber = paymentData.card.cardNumber;
        requestData.cardHolder = paymentData.card.cardHolder;
        requestData.cardBrand = paymentData.card.brand;
        requestData.encryptedCardNumber = paymentData.card.encryptedCardNumber;
        requestData.encryptedCardValidityMonth = paymentData.card.encryptedCardValidityMonth;
        requestData.encryptedCardValidityYear = paymentData.card.encryptedCardValidityYear;
        requestData.encryptedCardSecurityCode = paymentData.card.encryptedCardSecurityCode;
        requestData.isAdyen = paymentData.isAdyen;
        requestData.paymentToken = "";
      } {
        requestData.cardNumber = this.maskCreditCardNumber(paymentData.card.cardNumber);
        requestData.cardHolder = paymentData.card.cardHolder;
        requestData.cardBrand = paymentData.card.brand;
        requestData.expirationMonth = this.getExpirationMonth(paymentData.card.cardValidityDate);
        requestData.expirationYear = this.getExpirationYear(paymentData.card.cardValidityDate);
        requestData.paymentToken = "";
      }
      if (paymentData.paymentConditionIdentifier) {
        requestData.paymentConditionIdentifier = paymentData.paymentConditionIdentifier;
      } else {
        this.paymentOptions.forEach((paymentOption) => {
          if (paymentOption.identifier === 'CREDIT_CARD') {
            if (paymentOption.paymentConditionOptions && paymentOption.paymentConditionOptions.length) {
              let paymentConditionOptions = paymentOption.paymentConditionOptions.sort((a, b) => {
                return a.installments - b.installments;
              });

              requestData.paymentConditionIdentifier = paymentConditionOptions[paymentConditionOptions.length - 1].identifier;
            } else {
              requestData.paymentConditionIdentifier = 'creditCard1X';
            }
          }
        })

      }
    }

    requestData.productClassification = this.classificationIdentifier;

    this.selfAttendanceService.changePaymentMethod(requestData).subscribe(
      (selfAttendanceData: SelfAttendanceData) => {
        selfAttendanceData.businessId = this.businessId;
        selfAttendanceData.userId = this.userId;
        if (this.originOfRequest) {
          selfAttendanceData.service = this.originOfRequest;
        } else {
          if (selfAttendanceData.contract.status.includes('INVESTIGATED')) {
            selfAttendanceData.service = "paymentChangeInvestigate"
          } else {
            selfAttendanceData.service = 'paymentChange';
          }
        }
        this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
        this.closeDialogSpinner();
        this.router.navigate(['../sucesso'], { relativeTo: this.route });
      },
      (error) => {
        this.showCustomError('paymentChangeError', error);
      }
    )



  }

  showCustomError(customErrorKey: string, integrationError?: any) {
    let integrationErrorMessage: any;

    switch (customErrorKey) {
      case "termOfUsedIntegrationError":
        this.paymentForm.addValidationError(
          errorMapping[customErrorKey]
        );

        integrationErrorMessage = handleIntegrationError(integrationError);
        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      case "invalidPaymentOption":
        this.paymentForm.addValidationError(
          errorMapping[customErrorKey]
        );

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: "PaymentOptionInválido",
          errorMessage: errorMapping[customErrorKey],
        });
        break;
      case "paymentChangeDataError":
        integrationErrorMessage = this.showCustomHeroError(
          integrationError,
          "paymentChangeDataError"
        );

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      case "paymentChangeError":
        integrationErrorMessage = this.handlePaymentChange(integrationError);

        if (integrationErrorMessage.userMessage.includes("FRAUDNET_REJECT")) {
          this.openErrorDialog(integrationErrorMessage.userMessage, { customErrorKey });
        } else {
          if (integrationErrorMessage.context === "Fraudnet") {
            this.paymentForm.disableSubmit = true;
          }
          this.paymentForm.addValidationError(
            integrationErrorMessage.errors[0].text
          );
        }


        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        break;
      case "authenticationError":
        integrationErrorMessage = this.showCustomHeroError(
          integrationError,
          "authenticationError"
        );

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        this.showErrorHero = true;
        break;
      case "bankBillet2ndCopyError":
        integrationErrorMessage = this.showCustomHeroError(
          integrationError,
          "bankBillet2ndCopyError"
        );

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        this.showErrorHero = true;
        break;
      case "pix2ndCopyError":
        integrationErrorMessage = this.showCustomHeroError(
          integrationError,
          "pix2ndCopyError"
        );

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        this.showErrorHero = true;
        break;
      case "paymentMethodError":
        integrationErrorMessage = this.showCustomHeroError(
          integrationError,
          "paymentMethodError"
        );

        console.error(integrationErrorMessage);

        // Analytics
        this.dtmService.customErrorLoaded(["error"], {
          errorDetail: integrationErrorMessage.errorString,
          errorMessage: integrationErrorMessage.userMessage,
        });
        this.showErrorHero = true;
        break;
      default:
        break;
    }

    if (this.showForm) {
      this.paymentForm.submitting = false;
      this.paymentForm.enableFields("all");
    }


  }

  showCustomHeroError(error, type) {
    let resultError: any = {};

    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint = error.url;
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        resultError.errorString = `${resultError.status}:${resultError.name}:${resultError.endpoint
          }:${JSON.stringify(resultError.errors)}:${JSON.stringify(
            resultError.warnings
          )}`;

        resultError.userMessage = error.error._messages[0].text;
        resultError.code = error.error._messages[0].code;

        switch (type) {
          case "authenticationError":
            if (authReasonCode[resultError.code]) {
              this.heroData.type = "error";
              this.heroData.title = authReasonCode[resultError.code].title;
              this.heroData.contents =
                authReasonCode[resultError.code].contents;
            } else {
              this.heroData.type = "error";
              this.heroData.title = "Serviço indisponível!";
              this.heroData.contents = [
                "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
              ];
            }
            break;
          case "bankBillet2ndCopyError":
            if (bankBillet2ndCopyErrors[resultError.code]) {
              this.heroData.type = "error";
              this.heroData.title =
                bankBillet2ndCopyErrors[resultError.code].title;
              this.heroData.contents = bankBillet2ndCopyErrors[resultError.code].contents;
            } else {
              this.heroData.type = "error";
              this.heroData.title = "Serviço indisponível!";
              this.heroData.contents = [
                "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
              ];
            }
            break;
          case "pix2ndCopyError":
            if (pix2ndCopyErrors[resultError.code]) {
              this.heroData.type = pix2ndCopyErrors[resultError.code].type ? pix2ndCopyErrors[resultError.code].type : "error";
              this.heroData.title = pix2ndCopyErrors[resultError.code].title;
              this.heroData.contents = pix2ndCopyErrors[resultError.code].contents;
            } else {
              this.heroData.type = "warn";
              this.heroData.title = "Serviço indisponível!";
              this.heroData.contents = [
                "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
              ];
            }
            break;
          case "paymentMethodError":
            if (paymentMethodErrors[resultError.code]) {
              this.heroData.type = "warn";
              this.heroData.title =
                paymentMethodErrors[resultError.code].title;
              this.heroData.contents = paymentMethodErrors[resultError.code].contents;
            } else {
              this.heroData.type = "warn";
              this.heroData.title = "Serviço indisponível!";
              this.heroData.contents = [
                "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
              ];
            }
            break;
          case "paymentChangeDataError":
            if (paymentChangeDataError[resultError.code]) {
              this.heroData.type = resultError.code === '3' ? "warn" : "error";
              this.heroData.title = paymentChangeDataError[resultError.code].title;
              this.heroData.contents = paymentChangeDataError[resultError.code].contents;
            } else {
              this.heroData.type = "error";
              this.heroData.title = "Serviço indisponível!";
              this.heroData.contents = [
                "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
              ];
            }
            break;
          default:
            this.heroData.type = "error";
            this.heroData.title = "Serviço indisponível!";
            this.heroData.contents = [
              "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
            ];
            break;
        }
      }
    } catch (e) {
      console.error(e);
      resultError.errorString = JSON.stringify(error);
      this.heroData.type = "error";
      this.heroData.title = "Serviço indisponível!";
      this.heroData.contents = [
        "O Serviço que tentou acessar no momento está indisponível, tente novamente em alguns instantes.",
      ];
    }

    this.heroData.showButton = true;
    this.heroData.buttonName = "Ir para área logada";
    this.heroData.redirectURL = this.redirectUrl;

    this.showHero = true;
    return resultError;
  }

  handlePaymentChange(error: any): any {
    let resultError: any = {};

    try {
      if (typeof error === "string") {
        error = JSON.parse(error);
      }

      if (error.status && error.error) {
        resultError.status = error.status;
        resultError.endpoint =
          error.url && error.url.substring(error.url.indexOf("/api/1") + 6);
        resultError.name = error.name;

        resultError.handledError = !!error.error._messages.filter((message) => {
          return message.code !== null;
        });

        resultError.errors = error.error._messages.filter((message) => {
          return message.type === "ERROR";
        });

        resultError.warnings = error.error._messages.filter((message) => {
          return message.type === "WARNING";
        });

        let parseObj;
        try {
          parseObj = JSON.parse(resultError.errors[0].text);
        } catch (err) { }

        if (parseObj && parseObj.context !== undefined) {
          resultError.context = parseObj.context;
          resultError.userMessage = parseObj.message;
          resultError.errorCode = resultError.errors[0].code || parseObj.code;
          resultError.errors[0].text = resultError.userMessage;
        } else {
          resultError.userMessage = resultError.errors[0].text;
          resultError.errorCode = resultError.errors[0].code;
        }

        resultError.errorString = `${resultError.context || "SYDLE"}:HTTP:${resultError.errorCode || resultError.status
          }:POST/${resultError.endpoint}:${JSON.stringify(
            resultError.errors.map(({ text }) => text)
          )}:${JSON.stringify(resultError.warnings)}`;

        if (braspagReasonCode[resultError.userMessage]) {
          resultError.userMessage = braspagReasonCode[resultError.userMessage];
        } else if (adyenReasonCode[resultError.userMessage]) {
          resultError.userMessage = adyenReasonCode[resultError.userMessage];
        } else if (
          resultError.userMessage.indexOf("java") >= 0 ||
          resultError.userMessage.indexOf("Java") >= 0 ||
          resultError.userMessage.indexOf("Script") >= 0 ||
          resultError.userMessage.indexOf("script") >= 0 ||
          resultError.userMessage.indexOf("elastic") >= 0 ||
          resultError.userMessage.indexOf("Elastic") >= 0
        ) {
          resultError.userMessage =
            "Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes.";
        }
      }
    } catch (e) {

    }

    return resultError;
  }

  /** Abre dialog em caso de erro durante a venda deslogada */
  openErrorDialog(dialogData, params?) {
    const data = DialogData.fromPreset(dialogData, params);

    const dialogRef = this.dialog.open(DialogAlertComponent, {
      disableClose: true,
      panelClass: "pme-dialog-alert-panel",
      autoFocus: false,
      data: data,
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result.changeToBankBillet) {
        this.loading.addTask()

        this.selfAttendanceService.getBankBillet2ndCopy(this.businessId, this.userId, this.classificationIdentifier).subscribe(
          (selfAttendanceData) => {
            if (selfAttendanceData && selfAttendanceData.bankBilletData) {
              selfAttendanceData.businessId = this.businessId;
              selfAttendanceData.userId = this.userId;
              this.selfAttendanceService.setCurrentSelfAttendanceData(selfAttendanceData);
              this.router.navigate(['../sucesso'], { relativeTo: this.route });
              this.loading.finishTask();
            }
          },
          (error) => {
            this.showCurrentPlan = false;
            this.showForm = false;
            this.showCustomError('bankBillet2ndCopyError', error);
            this.loading.finishTask();
          }
        )
      }
    });
  }

  /**
   * Retorna um userMessage de erro para erros de HttpIntegrationError
   * @param error
   */
  getUserMessageForHttpIntegrationError(error: any): string {
    if (error && error.error) {
      error = error.error;

      if (error._messages && error._messages.length) {
        let isCvvInvalid = error._messages.some((errorMsg) =>
          errorMsg.text.includes("Código de segurança inválido")
        );
        if (isCvvInvalid) {
          return "Não autorizado. Código de segurança inválido. Revise os dados ou insira outro cartão.";
        }

        let isCardInexistent = error._messages.some((errorMsg) =>
          errorMsg.text.includes("Cartão inexistente")
        );
        if (isCardInexistent) {
          return "Transação não autorizada por conter dados inválidos. Revise os dados informados ou utilize outro cartão.";
        }

        let isCardRestricted = error._messages.some((errorMsg) =>
          errorMsg.text.includes("Cartão restrito")
        );
        if (isCardRestricted) {
          return "Cartão restrito. Não autorizado. Revise os dados informados ou utilize outro cartão.";
        }

        let isBP901Error = error._messages.some((errorMsg) =>
          errorMsg.text.includes("BP901")
        );
        if (isBP901Error) {
          return "Ocorreu um erro ao realizar a transação. Por favor revise os dados ou insira outro cartão.";
        }

        // Outras mensagens que podem ser retornadas pelo ONE
        let errors = error._messages.filter((err) => err.type == "ERROR");
        if (errors && errors.length) {
          return errors.map((err) => err.text).join(".");
        }
      }
    }

    return "Ocorreu um erro ao processar a solicitação, tente novamente em alguns instantes!";
  }

  // navigateToUrl() {

  //   if (this.redirectUrl) {
  //     window.location.href = this.redirectUrl;
  //     // this.router.navigateByUrl(this.redirectUrl);
  //   }
  //   this.location.back();
  // }
  maskCreditCardNumber(cardNumber: string): string {
    const unmaskedValue = cardNumber.substr(cardNumber.length - 4, 4);
    let maskedValue = cardNumber.substr(0, cardNumber.length - 4);
    maskedValue = maskedValue.split(' ').map(
      digitGroup => {
        let maskedGroup = '';
        while (maskedGroup.length < digitGroup.length) {
          maskedGroup += '*';
        }
        return maskedGroup;
      }
    ).join(' ');
    return maskedValue + unmaskedValue;
  }

  getExpirationMonth(expirationDate) {
    if (expirationDate) {
      let expirationMonth = expirationDate.split("/")[0];
      if (expirationMonth.length === 1) {
        return '0' + expirationMonth;
      } else {
        return expirationMonth;
      }
    } else {
      return '';
    }
  }

  getExpirationYear(expirationDate) {
    if (expirationDate) {
      let expirationYear = expirationDate.split("/")[1];
      return "20" + expirationYear;
    } else {
      return '';
    }
  }

  private loadDtmPageLoad() {
    switch (this.originOfRequest) {
      case '2via':
        this.dtmService.pageLoaded(Dtm.SegundaVia, true, getDtm(Dtm.SegundaVia, this.classificationIdentifier));
        break;
      case 'invoicingError':
        this.dtmService.pageLoaded(Dtm.RetencaoCartaoInvalido, true, getDtm(Dtm.RetencaoCartaoInvalido, this.classificationIdentifier));
        break;
      case 'expiredBankBillet':
        this.dtmService.pageLoaded(Dtm.RetencaoBoletoVencido, true, getDtm(Dtm.RetencaoBoletoVencido, this.classificationIdentifier));
        break;
      default:
        this.dtmService.pageLoaded(Dtm.AlteracaoDePagamento, true, getDtm(Dtm.AlteracaoDePagamento, this.classificationIdentifier));
        break;
    }

    this.dtmService.sendPageLoadEvent();
  }

  handleDeleteCreditCard(accountPaymentDataId: string): void {
    this.selfAttendanceService.removeCreditCard(this.userId, this.businessId, accountPaymentDataId)
      .subscribe(results => {
        this.creditCardsData = results[0].length ? results[0] : null;
        this.maxLimitCreditCards = results[1];
      });
  }
}
